const guiColors = {
    'looks-secondary': 'hsla(200, 100%, 70%, 1)',
    'looks-transparent': 'hsla(200, 100%, 70%, 0.35)',
    'looks-light-transparent': 'hsla(200, 100%, 70%, 0.15)',
    'looks-secondary-dark': 'hsla(200, 60%, 40%, 1)'
};

const blockColors = {};
export {
    guiColors,
    blockColors
};